import script from "./ServiceAgreement.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServiceAgreement.vue?vue&type=script&setup=true&lang=ts"

import "./ServiceAgreement.vue?vue&type=style&index=0&id=2ad4cf9b&scoped=true&lang=less"

import exportComponent from "/data/liulv-h5/International-card-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ad4cf9b"]])

export default __exports__